import { render, staticRenderFns } from "./basic-information-icon.vue?vue&type=template&id=0c37c6b9&scoped=true&"
import script from "./basic-information-icon.vue?vue&type=script&lang=js&"
export * from "./basic-information-icon.vue?vue&type=script&lang=js&"
import style0 from "./basic-information-icon.vue?vue&type=style&index=0&id=0c37c6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c37c6b9",
  null
  
)

export default component.exports